export enum StorageKeys {
    BIO2_CLIENT_ID = 'BIO2_ClientId',
    BIO2_CLIENT_USERNAME = 'BIO2_ClientUsername',
    BIO2_CLIENT_COMMERCIAL_CONDITION = 'BIO2_CommercialCondition',
    BIO2_CLIENT_ADDRESS_ID = 'BIO2_AddressId',
    BIO2_SELECTED_CHANGED_ADDRESS = 'BIO2_SelectedChangedAddress',
    BIO2_CLIENT_ADDRESSES = 'BIO2_ClienteAddresses'
}